import axios from 'axios';

const { apiHost = '' } = window.chatwootConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}/` });

// Ensure backend errors and Devise flows (signup/reset) use the same locale as the UI.
// SwitchLocale prioritizes params[:locale], which works even for unauthenticated endpoints.
wootAPI.interceptors.request.use(config => {
  const selectedLocale = window.chatwootConfig?.selectedLocale;
  if (selectedLocale) {
    config.params = { ...(config.params || {}), locale: selectedLocale };
  }
  return config;
});

export default wootAPI;
